import Image from 'next/image';
import Paragraph from 'structure/launchpad/components/Typography';
import React from 'react';
import { StakingPool, StakingProject } from 'api/StakingAPI';
import { getNetworkFromChainId } from '@dapp/multi-lib/network';
import { getStaticAssetUrl } from 'utils/url';

export function StakingPoolIcon({
  pool,
  project,
}: {
  pool: StakingPool;
  project?: StakingProject;
}) {
  const networkInfo = getNetworkFromChainId(pool.chainId);
  return (
    <div className='flex flex-row items-center gap-4'>
      <div className='relative h-8 min-h-8 w-8 min-w-8'>
        <Image
          height={32}
          width={32}
          src={getStaticAssetUrl(
            `/sfi/static/image/token/${pool.depositTokenSymbol}.svg`
          )}
          alt={pool.depositTokenSymbol}
        />
        <div className='absolute -bottom-2 -right-2 h-6 w-6 rounded-full bg-black p-1.5'>
          <Image
            alt={networkInfo.nativeCurrency.symbol}
            src={getStaticAssetUrl(
              `/sfi/static/image/token/${networkInfo.nativeCurrency.symbol}.svg`
            )}
            height={20}
            width={20}
          />
        </div>
      </div>
      <div className='flex flex-col gap-1'>
        <Paragraph className='text-xs text-[#B4BCD0]'>
          {pool.depositTokenSymbol}
        </Paragraph>
        <Paragraph className='text-xs text-[#B4BCD0]'>
          {networkInfo.shortName}
        </Paragraph>
      </div>
    </div>
  );
}
